import type { FaireReviewEntity } from "../../entity_types/review";

// Real product review, pulled from Sweet Wink's live Faire product page for
// the Gold Tiara Headband (faire.com/product/p_z7fktr7rcu), via the
// authenticated PDP reviews API (verbatim reviewer name/location/text/date —
// nothing paraphrased or invented).
export const review_sw4: FaireReviewEntity = {
  token: "review_sw4",
  type: "review",
  brandName: "Sweet Wink",
  brandToken: "b_gro99lye",
  productToken: "p_z7fktr7rcu",
  productImageUrl:
    "https://cdn.faire.com/fastly/4c0a1688dbce4f1654c7331dd8f0a9f01a4a132ccba55a80bb185eb4a6cc071f.jpeg",
  reviewerName: "Linda H.",
  reviewerLocation: "Gloucester, MA",
  stars: 5,
  reviewText:
    "I was a little worried about the fabric on the capes and was hopefully that it would not be scratchy for little kids but the fabric used is soft and durable. Really eye-catching pieces and accessories, and also very size-inclusive.",
  reviewDate: "May 19, 2022",
  reviewType: "product",
  meta: {
    source: "api",
    importedAt: "2026-08-11T21:28:00.000Z",
    importedBy: "entity-db-cli",
  },
};
